module.exports = __webpack_public_path__ + "static/img/bg_2_9.fb6e8ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_2_9.png
// module id = 8s+N
// module chunks = 3